"use client";
import LayoutWrapper from "./LayoutWrapper";
import PnrForm from "./PnrForm";
import Form from "./form";

const CarSearchFormWrapper = (props) => {
  return (
    <LayoutWrapper
      pnrFormComponent={PnrForm}
      translationNamespace="common"
      hidePnrSection={props.hidePnrSection}
      hideCampaignListener={props.hideCampaignListener}
    >
      <Form {...props} />
    </LayoutWrapper>
  );
};

export default CarSearchFormWrapper;
